import { useSelector } from 'react-redux';
import { asTree } from 'utils';

function useTree() {
  return useSelector(({ graph }) => asTree(graph));
};

export default useTree;
